import { memo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useRoomCatchCopy } from "./hooks";

export const QuestionCatchCopy = memo(() => {
	const { catchCopy, onSetMainTarget } = useRoomCatchCopy();

	const onChange = (value: string) => {
		onSetMainTarget(value);
	};

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"キャッチコピー"}
			guide="ゲストに記事が表示される際のタイトルになります。短くシンプルなキャッチコピーにしましょう。30文字まで入力できます。"
			isEdited={catchCopy?.isEdited ?? false}
			hasError={Boolean(catchCopy?.error)}
			inputChildren={
				<InputTextField
					type="text"
					errorMessage={catchCopy?.error}
					value={catchCopy?.value ?? undefined}
					handleChange={onChange}
				/>
			}
		/>
	);
});

QuestionCatchCopy.displayName = "QuestionCatchCopy";
